export const SET_IS_POLICY_ACCEPTED = 'application/SET_IS_POLICY_ACCEPTED';
export const SET_IS_NAV_COLLAPSED = 'application/SET_IS_NAV_COLLAPSED';
